import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {HeaderService} from '../../core/services/header.service';
import {AuthService} from '../../core/security/auth.service';
import {merge, Subscription} from 'rxjs';
import {RolesEnum} from '../../core/security/roles.enum';
import {MatPaginator} from '@angular/material/paginator';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {debounceTime, tap} from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';
import {PhoneNumberDatasource} from './phone-number.datasource';
import {PhoneNumbersService as PhoneNumbersApiService} from '../../api/services/phone-numbers.service';
import {PhoneNumberModel} from '../../api/models/phone-number-model';
import {SelectionModel} from '@angular/cdk/collections';
import {BulkEditComponent} from '../bulk-edit/bulk-edit.component';
import {PhoneNumbersRequest} from '../../api/models/phone-numbers-request';
import {GridSortService} from '../../core/services/grid-sort.service';
import { FlexModule } from '@angular/flex-layout';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatCheckbox } from '@angular/material/checkbox';
import { RouterLink } from '@angular/router';
import { ExplanationComponent } from '../../core/visual/explanation/explanation.component';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { PhoneNumberPipe } from '../../core/pipes/phone-number.pipe';

@Component({
    selector: 'app-phone-number-grid',
    templateUrl: './phone-number-grid.component.html',
    styleUrls: ['./phone-number-grid.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        NgIf,
        MatProgressSpinner,
        MatTable,
        MatSort,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatCellDef,
        MatCell,
        MatCheckbox,
        MatSortHeader,
        RouterLink,
        ExplanationComponent,
        MatIconButton,
        MatTooltip,
        MatIcon,
        NgFor,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        MatPaginator,
        AsyncPipe,
        PhoneNumberPipe,
    ],
})
export class PhoneNumberGridComponent implements OnDestroy, OnInit, AfterViewInit {
  displayedColumns: string[] = ['select', 'number', 'customerDidAlias', 'phoneNumberStatusName', 'phoneNumberType', 'cnam', 'allUsers'/*, 'campaignNumber'*/, 'feature'];
  @Input() filterChangeEvent: EventEmitter<void>;
  @Input() showAdditionalColumns = false;
  hasSupportAccess = false;
  additionalFilter: any = {};
  recIdFilter: string;
  isLoading = false;
  searchText: string;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSource: PhoneNumberDatasource;
  selectedRows: SelectionModel<PhoneNumberModel>;
  detailsUrl: string;

  hasEditAccess = false;
  private currentUserSubscription: Subscription;

  constructor(public gridSortService: GridSortService,
              private phoneNumbersApiService: PhoneNumbersApiService,
              public dialog: MatDialog,
              public headerService: HeaderService, public authService: AuthService) {

    this.currentUserSubscription = this.authService.currentUser.subscribe((data) => {
      this.hasEditAccess = this.authService.hasAccess([RolesEnum.PhoneNumbers_Edit, RolesEnum.PhoneNumbers_Delete]);
    });
  }

  ngOnInit() {
    this.hasSupportAccess = this.authService.hasAccess([RolesEnum.Support]);
    this.dataSource = new PhoneNumberDatasource(this.phoneNumbersApiService);

    this.detailsUrl = '../phone-number';

    const initialSelection = [];
    const allowMultiSelect = true;
    this.selectedRows = new SelectionModel<PhoneNumberModel>(allowMultiSelect, initialSelection);
  }

  ngAfterViewInit() {
    this.filterChangeEvent?.subscribe((filter) => {
      this.additionalFilter = filter;
      this.paginator.pageIndex = 0;
    });

    this.gridSortService.gridSortSubject.subscribe(() => {
      const currentSort = this.gridSortService.gridSortSubject.getValue();
      if (currentSort) {
        if (currentSort.active !== this.sort.active || currentSort.direction !== this.sort.direction) {
          this.sort.sort({
            id: currentSort.active,
            start: currentSort.direction || 'asc',
            disableClear: true
          });
        }
      }
    });

    this.sort.sortChange.subscribe((sort) => {
      console.log('sortChange', sort);
      this.gridSortService.gridSortSubject.next(sort);
      this.paginator.pageIndex = 0;
    });

    merge(this.sort.sortChange, this.paginator.page, this.filterChangeEvent)
      .pipe(debounceTime(10))
      .pipe(
        tap(() => this.loadCallLogs())
      )
      .subscribe();
  }

  loadCallLogs() {
    console.log('filter changed');
    this.dataSource.queryData(this.getDataFilter());
  }

  getDataFilter(): PhoneNumbersRequest {
    const baseRequest = {
      skip: this.paginator.pageIndex * this.paginator.pageSize,
      limit: this.paginator.pageSize,
      sort: [{field: this.sort.active, direction: this.sort.direction ? this.sort.direction.toUpperCase() : undefined}],
    };

    return Object.assign(baseRequest, this.additionalFilter || {});
  }

  ngOnDestroy() {
    console.log('ngOnDestroy');
    this.gridSortService.gridSortSubject.next(null);
    this.currentUserSubscription?.unsubscribe();
  }

  onCnamEdit(row: PhoneNumberModel) {
    const dialogRef = this.dialog.open(BulkEditComponent, {
      width: '400px',
      data: {
        ids: [row.id],
        cnam: row.cnam,
      }
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result === 'success') {
        this.onBulkEditSuccess();
      }
    });
  }

  onBulkEditSuccess() {
    this.selectedRows.clear();
    this.filterChangeEvent.emit();
  }
}
